import { Button, Card, Heading, Paragraph } from '@deckee/deck-hand';
import React, { FC } from 'react';

export interface InsuranceCardInterface {
  name: string;
  description: string | React.ReactElement;
  url: string;
  imageUrl: string;
  buttonText?: string;
  providerName?: string;
}

interface InsuranceCardProps extends InsuranceCardInterface {
  role: string;
  onSelectInsurance: (insuranceOffer: InsuranceCardInterface) => void;
}

const InsuranceCard: FC<InsuranceCardProps> = ({
  name,
  description,
  imageUrl,
  url,
  buttonText,
  role,
  providerName,
  onSelectInsurance,
}) => {
  const handleClick = () => {
    onSelectInsurance({ name, description, url, imageUrl, providerName });
  };
  return (
    <Card role={role}>
      <Card.HeadImage imageUrl={imageUrl} />
      <Card.Body>
        <Heading level={4}>{name}</Heading>
        <Paragraph as="div">{description}</Paragraph>
        <Button wide onClick={handleClick}>
          {buttonText}
        </Button>
      </Card.Body>
    </Card>
  );
};

InsuranceCard.defaultProps = {
  buttonText: 'Start free quote',
  providerName: '',
};

export default InsuranceCard;
